/**
 * Retro Arcade Theme — Last NAD Standing
 * Cyan + Purple pixel palette, Press Start 2P font, CRT effects.
 */

export const cyberpunkTheme = {
  colors: {
    primary: '#00f5ff',
    secondary: '#a855f7',
    accent: '#ff0040',
    success: '#00f5ff',
    danger: '#ff0040',
    warning: '#ff9500',  // WCAG AAA compliant on dark backgrounds (7.76:1)

    bg: {
      darkest: '#0d0d1a',
      dark: '#10101f',
      darker: '#0e0e1c',
      card: 'rgba(16, 16, 31, 0.92)',
      cardHover: 'rgba(20, 20, 38, 0.95)',
      overlay: 'rgba(0, 0, 0, 0.88)',
    },

    text: {
      primary: '#e0e0f0',
      secondary: '#7a7a9a',
      muted: '#4a4a6a',
      neon: '#00f5ff',
    },

    border: {
      default: 'rgba(0, 245, 255, 0.15)',
      hover: 'rgba(0, 245, 255, 0.4)',
      active: 'rgba(0, 245, 255, 0.65)',
    },

    glow: {
      cyan: '0 0 12px rgba(0, 245, 255, 0.3), 0 0 24px rgba(0, 245, 255, 0.15)',
      cyanStrong: '0 0 20px rgba(0, 245, 255, 0.5), 0 0 40px rgba(0, 245, 255, 0.2)',
      magenta: '0 0 12px rgba(168, 85, 247, 0.4), 0 0 24px rgba(168, 85, 247, 0.2)',
      // warning/orange glow — WCAG AAA compliant (#ff9500)
      warning: '0 0 12px rgba(255, 149, 0, 0.4), 0 0 24px rgba(255, 149, 0, 0.2)',
      // keep yellow as alias for backward compat
      yellow: '0 0 12px rgba(255, 149, 0, 0.4), 0 0 24px rgba(255, 149, 0, 0.2)',
    },

    button: {
      accent: 'linear-gradient(180deg, #00f5ff 0%, #00c8d4 100%)',
      accentHover: 'linear-gradient(180deg, #40faff 0%, #00f5ff 100%)',
    },
  },

  fonts: {
    display: "'Press Start 2P', 'Courier New', monospace",
    body: "'JetBrains Mono', 'Courier New', monospace",
    mono: "'JetBrains Mono', 'Courier New', monospace",
    number: "'Russo One', sans-serif",
  },

  animations: {
    neonPulse: `
      @keyframes neonPulse {
        0%, 100% { opacity: 1; text-shadow: 0 0 8px rgba(0, 245, 255, 0.6), 0 0 16px rgba(0, 245, 255, 0.3); }
        50% { opacity: 0.85; text-shadow: 0 0 12px rgba(0, 245, 255, 0.8), 0 0 24px rgba(0, 245, 255, 0.4); }
      }
    `,
    scanline: `
      @keyframes scanline {
        0% { transform: translateY(-100%); }
        100% { transform: translateY(100%); }
      }
    `,
    float: `
      @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-6px); }
      }
    `,
    fadeIn: `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
    `,
    slideUp: `
      @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `,
    glitch: `
      @keyframes glitch {
        0%, 90%, 100% { opacity: 0; transform: translate(0); }
        91% { opacity: 0.7; transform: translate(-3px, 2px); clip-path: inset(20% 0 60% 0); }
        93% { opacity: 0.5; transform: translate(3px, -1px); clip-path: inset(50% 0 20% 0); }
        95% { opacity: 0; }
      }
    `,
    blink: `
      @keyframes blink {
        0%, 60% { opacity: 1; }
        61%, 100% { opacity: 0; }
      }
    `,
  },
}
